import React, { useEffect } from "react";
import { compose, withActions, withAppContext, withState } from "containers/HOC";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import * as utils from "common/utils";
import { getMyOrgRecentActivity } from "containers/MyOrg/_actions";
import { Link } from "react-router-dom";
import LoaderSection from "./LoaderSection";
import TileBodyMessage from "components/TileBodyMessage";
import * as icons from "common/icons";

const RecentActivity = ({ getMyOrgRecentActivity, authContext, activity = [], activityLoading }) => {
    useEffect(() => {
        getMyOrgRecentActivity(5, authContext.accountId);
    }, [getMyOrgRecentActivity, authContext.accountId]);

    return (
        <Panel title="Latest activity" collapsible loading={activityLoading} stickyHeaderName="dashboard.recentorgactivity.collapsed" collapsed={true}>
            {activityLoading && activity.length === 0 ? (
                <LoaderSection />
            ) : (
                <>
                    {activity.length === 0 ? (
                        <PanelBody>
                            <TileBodyMessage className="u-mt-md u-mb-md">
                                <img src={icons.search} alt="Plus" />
                                <p className="lead">No recent activity</p>
                            </TileBodyMessage>
                        </PanelBody>
                    ) : (
                        <PanelBody>
                            <div className="Table Table-Compressed">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Farm</th>
                                            {authContext.isAdmin && <th>User</th>}
                                            <th>Analysis</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {activity.map((a) => {
                                            return (
                                                <tr key={a.changedOn}>
                                                    <td>{utils.dateOnly(a.changedOn)}</td>
                                                    <td>
                                                        <Link to={`/app/farm/${a.farmId}`}>{a.farmName}</Link>
                                                    </td>
                                                    {authContext.isAdmin && <td>{a.userName}</td>}
                                                    <td>
                                                        <Link to={`/app/farm/${a.farmId}/analysis/${a.budgetId}`}>{a.budgetName}</Link>
                                                    </td>
                                                    <td>{a.description}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </PanelBody>
                    )}
                </>
            )}
        </Panel>
    );
};

export default compose(
    withAppContext,
    withActions({ getMyOrgRecentActivity }),
    withState((state) => {
        return {
            activity: state.myOrg.activity,
            activityLoading: state.myOrg.activityLoading,
        };
    })
)(RecentActivity);
